import { toast } from './toaster';
import type { PersistWriteFailureReason } from '../../core/storage/guardedJsonStorage';

/**
 * User-facing notice for a dropped persist write (see guardedJsonStorage.ts).
 * Shared by the persisted stores that hold user-authored content, so the copy
 * stays identical.
 *
 * `userLabel` is used as a sentence subject ("Your workspace is too large to
 * write"), so a plural label ("your SQL snippets") must say so — otherwise the
 * verb disagrees.
 */
export function showPersistWriteFailureToast(
  userLabel: string,
  options: { plural?: boolean } = {},
): (reason: PersistWriteFailureReason) => void {
  return (reason) => {
    const subject = `${userLabel[0].toUpperCase()}${userLabel.slice(1)}`;
    const description =
      reason === 'quota'
        ? 'Storage is full. Close some tabs or save large scripts to .sql files; your last saved state is kept.'
        : reason === 'string_length'
          ? `${subject} ${options.plural ? 'are' : 'is'} too large to write. Close some tabs or save large scripts to .sql files; your last saved state is kept.`
          : 'The write failed. Your last saved state is kept.';
    toast.error({ title: `Could not save ${userLabel}`, description });
  };
}
